import { Heatmap as HeatmapLayer } from 'ol/layer.js';
import vectorLayer from 'vuelayers/lib/mixin/vector-layer';
import { pick } from 'vuelayers/lib/util/minilo';

var RENDER_MODES = ['vector', 'image'];
/**
 * @vueProps
 */

var props = {
  /**
   * Render mode for vector layers. Available values:
   * - `image` - vector layers are rendered as images
   * - `vector` - vector layers are rendered as vectors
   * @type {string}
   * @default vector
   */
  renderMode: {
    type: String,
    default: 'vector',
    validator: function validator(val) {
      return RENDER_MODES.includes(val);
    }
  },

  blur: {
    type: Number,
    default: 15
  },

  radius: {
    type: Number,
    default: 8
  },

  shadow: {
    type: Number,
    default: 250
  },

  weight: {
    type: [ String, Function ],
    default: 'weight'
  },

  gradient: {
    type: Array,
    default: function() {
        return ['#00f', '#0ff', '#0f0', '#ff0', '#f00']
    }
  }


  /**
   * @vueMethods
   */

};
var methods = {
  /**
   * @return {Vector}
   * @protected
   */
  createLayer: function createLayer() {
    return new HeatmapLayer({
      id: this.id,
      minResolution: this.minResolution,
      maxResolution: this.maxResolution,
      opacity: this.opacity,
      visible: this.visible,
      extent: this.extent,
      zIndex: this.zIndex,
      updateWhileAnimating: this.updateWhileAnimating,
      updateWhileInteracting: this.updateWhileInteracting,
      source: this._source,
      renderMode: this.renderMode,
      renderBuffer: this.renderBuffer,
      renderOrder: this.renderOrder,
      declutter: this.declutter,
      blur: this.blur,
      radius: this.radius,
      shadow: this.shadow,
      weight: this.weight,
      gradient: this.gradient
    });
  }
};
/**
 * Layer for data that is rendered client-side.
 *
 * @vueProto
 * @title vl-layer-vector
 * @alias module:vector-layer/layer
 *
 * @vueSlot default Default slot for `vl-source-*` (vector-like only) components.
 */
var watch = {
    blur: function( value ) {
        if( this.$layer && value !== this.$layer.getBlur() )
            this.$layer.setBlur( value );
    },
    radius: function( value ) {
        if (this.$layer && value !== this.$layer.getRadius())
            this.$layer.setRadius( value );
    }
};
var script = {
  name: 'vl-layer-heatmap',
  mixins: [vectorLayer],
  props: props,
  methods: methods,
  watch: watch
};

/* script */
var __vue_script__ = script;
/* template */

/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = undefined;
/* component normalizer */

function __vue_normalize__(template, style, script$$1, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  var component = (typeof script$$1 === 'function' ? script$$1.options : script$$1) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "HeatmapLayer.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}
/* style inject */

/* style inject SSR */


var Layer = __vue_normalize__({}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);

function plugin(Vue, options) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (plugin.installed) {
    return;
  }

  plugin.installed = true;
  options = pick(options, 'dataProjection');

  Object.assign(Layer, options);

  Vue.component(Layer.name, Layer);
}

export default plugin;
export { Layer, plugin as install };

